import { normalizeCadenceDiscountPct } from './calculateTotalFees';

export function formatCadenceAdjustmentLabel(discountPct, { includeZero = false } = {}) {
  const pct = normalizeCadenceDiscountPct(discountPct);
  if (!pct) return includeZero ? '0%' : '';
  return `${Math.abs(pct)}% ${pct > 0 ? 'discount' : 'premium'}`;
}

export function formatCadenceOptionLabel(label, discountPct) {
  const adjustment = formatCadenceAdjustmentLabel(discountPct);
  return adjustment ? `${label} (${adjustment})` : label;
}
